import { createTheme } from '@mui/material/styles';

export const BBraunTheme = createTheme({
    palette: {
        primary: {
            main: "#00B482"
        },
        secondary: {
            main: "#f2f2f2"
        },
        accent: {
            main: "#711E82"
        }
    },
    status: {
        danger: 'red',
    },
    typography: {
        fontFamily: [
            'Arial',
            'Roboto',
            'Helvetica',
            'Open Sans',
            'sans-serif'
        ].join(',')
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#00B482',
                    '&:hover': {
                        color: '#008f6a'
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                text: {
                    color: '#00B482',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 180, 130, 0.08)'
                    }
                },
                contained: {
                    backgroundColor: '#00B482',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#008f6a'
                    }
                },
                containedPrimary: {
                    backgroundColor: '#00B482',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#008f6a'
                    }
                }
            }
        }
    }
});
